import { UseFormReturn } from "react-hook-form";
import { useState } from "react";
import { Step } from "./constants";
import { CaretLeft } from "@phosphor-icons/react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { DrawerHeader } from "@/components/ui/drawer";
import { useTranslation } from "react-i18next";
import { ExecutionEntryFormValues } from "./index";

const NotesStep = ({
  form,
  setStep,
}: {
  form: UseFormReturn<ExecutionEntryFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();
  const [note, setNote] = useState(form.getValues("notes") ?? "");

  return (
    <div>
      <DrawerHeader
        title={t("label.add_note")}
        leftButton={
          <button type="button" onClick={() => setStep(Step.INITIAL)}>
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-[18px]" />}
      />

      <Textarea
        data-testid="execution-entry-form-notes-input"
        className="h-[200px]"
        placeholder={t("label.enter_note")}
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />

      <Button
        data-testid="execution-entry-form-notes-submit-button"
        className="mt-4 w-full"
        onClick={() => {
          form.setValue("notes", note);
          setStep(Step.INITIAL);
        }}
      >
        {t("button.add")}
      </Button>
    </div>
  );
};

export default NotesStep;
